<template>
  <v-dialog :value="dialogStatus" @input="$emit('input', $event)" width="700">
    <v-card>
      <v-card-title>
        <v-layout row wrap>
          <v-flex xs10 sm10 md10 class="headline">{{ $t('rms_edit_invitation_label') }}</v-flex>
          <v-flex xs2 sm2 md2 class="text-xs-right">
            <v-btn small dark icon color="red" @click="dialogStatus = false">
              <v-icon small class="white--text">$vuetify.icons.rms_close</v-icon>
            </v-btn>
          </v-flex>
        </v-layout>
      </v-card-title>
      <v-card-text class="pt-0">
        <v-form ref="form" lazy-validation class="mt-4">
          <!-- Emails input field -->
          <v-text-field
            outline
            v-model="update_link.email"
            :label="$t('rms_avail_link_invitee_email_label')"
            readonly
          ></v-text-field>
          <!-- Phone number input field -->
          <v-text-field
            outline
            v-model="update_link.created_at"
            :label="$t('rms_avail_link_creation_date_label')"
            readonly
          ></v-text-field>
          <!-- Expiry days select box -->
          <v-select
            outline
            v-model="update_link.expire_in_days"
            :items="timeLimits"
            item-text="title"
            item-value="value"
            :label="$t('rms_invitation_link_expire_label')"
            @change="calculateDateFromDays()"
          ></v-select>

          <!-- Expiry date field (value depends on selected expiry days) -->
          <v-text-field
            outline
            :label="$t('rms_expire_link_label')"
            v-if="update_link.expire_in_days"
            readonly
            :value="moment(update_link.expiry_date).format('ll')"
          ></v-text-field>

          <v-layout row wrap>
            <v-flex xs12 sm12 md6>
              <!-- checkbox for screener allow permission -->
              <v-checkbox
                class="title"
                :label="$t('rms.invitation_form.screeners_field.label')"
                v-model="update_link.is_screener_allowed"
                color="green"
              ></v-checkbox>
            </v-flex>

            <v-flex xs12 sm12 md6>
              <!-- Checkbox for refine search in filters allow permission -->
              <v-checkbox
                class="title"
                :label="$t('rms.invitation_form.refine_search_field.label')"
                v-model="update_link.is_search_filters_allowed"
                color="green"
              ></v-checkbox>
            </v-flex>
          </v-layout>
        </v-form>
      </v-card-text>

      <v-card-actions>
        <v-btn block color="green" dark @click="update()">{{ $t('rms_update_btn_label') }}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import rules from "@/validation";
import { link } from "fs";
export default {
  data() {
    return {
      rules,
      update_link: {
        email: null,
        expire_in_days: null,
        is_screener_allowed: false,
        is_search_filters_allowed: false,
        created_at: null,
        expiry_date: null,
        is_mark_expire: false
      }
    };
  },
  props: ["dialog", "link", "timeLimits"],
  computed: {
    dialogStatus: {
      get() {
        return this.dialog;
      },
      set(value) {
        this.$emit("input", value);
      }
    }
  },

  mounted() {
    this.setLink();
  },

  methods: {
    setLink() {
      this.update_link.email = this.link.created_for_email;
      this.update_link.created_at = this.moment(this.link.created_at).format(
        "YYYY-MM-DD"
      );
      this.update_link.expire_in_days = this.diffInDays(
        this.link.created_at,
        this.link.expiry_date
      );
      this.update_link.is_screener_allowed = this.link.is_screener_allowed;
      this.update_link.is_search_filters_allowed = this.link.is_search_filters_allowed;
      this.update_link.expiry_date = this.calculateDateFromDays();
    },

    diffInDays(created_at, expired_at) {
      let creation_date = this.moment(created_at);
      let expiration_date = this.moment(expired_at);
      let days = expiration_date.diff(creation_date, "days");
      return days + 1;
    },

    calculateDateFromDays() {
      let expiry_date = this.moment(this.link.created_at).add(
        this.update_link.expire_in_days,
        "days"
      );
      this.update_link.expiry_date = expiry_date;
      return expiry_date;
    },

    async update() {
      await this.$store.dispatch("avails/update", {
        id: this.link.id,
        expiry_date: this.moment(this.update_link.expiry_date).format(
          "YYYY-MM-DD"
        ),
        is_screener_allowed: this.update_link.is_screener_allowed,
        is_search_filters_allowed: this.update_link.is_search_filters_allowed
      });
      this.dialogStatus = false;
    }
  }
};
</script>

<style></style>
